import ReactLoading from 'react-loading';
import FitButtons from '../Components/FitButton';
import { RiInformationFill } from 'react-icons/ri';
import { useState } from 'react';
import { Currencies } from '../Components/Currencies';
import axios from 'axios';
import { getToken, windowReload } from '../utils';
import { toast } from 'react-toastify';

const formData = {
  account_type_id: '',
  currency_id: '',
  first_name: '',
  last_name: '',
  other_name: '',
  bank_name: '',
  bank_address: '',
  iban_number: '',
  country_id: '',
  additional_info: '',
  swift_code: '',
};

export const FormfieldForeign = (props) => {
  const { token: userToken } = getToken();

  const [inputs, setInputs] = useState(formData);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const { currencys, countrys, accountTypes } = Currencies();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmiting(true);
      axios.post(
        `${process.env.REACT_APP_BASE_URL}/cx-accounts/store`,
        inputs,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      setInputs(formData);
      props.toggleAddAccountForm();
      toast.success('Accont successfully added');
      windowReload();
    } catch (error) {
      setInputs(formData);
      console.log(error, 'error now');
    } finally {
      setIsSubmiting(false);
    }
  };

  const halfInputs = [
    {
      id: 1,
      label: 'First name',
      type: 'text',
      name: 'first_name',
      value: inputs.first_name,
      onchange: handleChange,
    },
    {
      id: 2,
      label: 'Last name',
      type: 'text',
      name: 'last_name',
      value: inputs.last_name,
      onchange: handleChange,
    },
    {
      id: 3,
      label: 'Other name',
      type: 'text',
      name: 'other_name',
      value: inputs.other_name,
      onchange: handleChange,
    },
    {
      id: 4,
      label: 'Swift code',
      type: 'number',
      name: 'swift_code',
      value: inputs.swift_code,
      onchange: handleChange,
    },
  ];
  const fullInputs = [
    {
      id: 1,
      label: 'Bank name',
      type: 'text',
      name: 'bank_name',
      value: inputs.bank_name,
      onchange: handleChange,
    },

    {
      id: 2,
      label: 'Iban number',
      type: 'number',
      name: 'iban_number',
      value: inputs.iban_number,
      onchange: handleChange,
    },
    {
      id: 3,
      label: 'Bank address',
      type: 'text',
      name: 'bank_address',
      value: inputs.bank_address,
      onchange: handleChange,
    },
    {
      id: 4,
      label: 'Additional information',
      type: 'text',
      name: 'additional_info',
      value: inputs.additional_info,
      onchange: handleChange,
    },
  ];
  const selectInputs = [
    {
      id: 1,
      label: 'Country',
      name: 'country_id',
      value: inputs.country_id,
      option: countrys,
      onchange: handleChange,
    },

    {
      id: 2,
      label: 'Account Currency',
      name: 'currency_id',
      value: inputs.currency_id,
      option: currencys,
      onchange: handleChange,
    },
    {
      id: 3,
      label: 'Account type',
      name: 'account_type_id',
      value: inputs.account_type_id,
      option: accountTypes,
      onchange: handleChange,
    },
  ];

  return (
    <section className='w-full flex flex-col gap-16 px-6 py-8 drop-shadow-lg bg-p-wh rounded mx-auto'>
      <div className='flex flex-row gap-2 text-s-bk bg-b-mct px-4 py-4 rounded-lg'>
        <span className='text-2xl'>
          <RiInformationFill />
        </span>
        <p className='text-sm'>
          This payment method will be use for transacting in Loyaltyview.
          Therefore while filling the form ensure that the information is
          correct, active, and matches your KYC information you provided
        </p>
      </div>
      <form className='w-full flex flex-col gap-16' onSubmit={handleSubmit}>
        <div className='w-full flex flex-col md:flex-row gap-6'>
          <div className='w-full flex gap-8 flex-col'>
            <div className='grid sm:grid-cols-2 gap-6 gap-x-6 gap-y-8'>
              {halfInputs.map((input) => (
                <div
                  className=' w-full flex flex-col gap-2 col-span-1'
                  key={input.id}
                >
                  <label className='text-p-bk text-base font-pin relative'>
                    {input.label}
                  </label>

                  <input
                    type={input.type}
                    name={input.name}
                    className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-14 px-4 rounded-lg'
                    value={input.value}
                    onChange={input.onchange}
                    required
                  />
                </div>
              ))}
            </div>
            {selectInputs?.map((select) => (
              <div className=' w-full flex flex-col gap-2' key={select?.id}>
                <label className='text-p-bk text-base font-pin relative'>
                  {select?.label}
                </label>
                <select
                  name={select?.name}
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-14 px-4 rounded-lg'
                  value={select?.value}
                  onChange={select?.onchange}
                  required
                >
                  <option>. . . . Select . . . . </option>
                  {select?.option?.map((data) => (
                    <option className='py-8' key={data?.id} value={data?.id}>
                      {data?.name}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
          <div className='w-full flex gap-8 flex-col'>
            {fullInputs.map((fullInput) => (
              <div className=' w-full flex flex-col gap-2' key={fullInput.id}>
                <label className='text-p-bk text-base font-pin relative'>
                  {fullInput.label}
                </label>

                <input
                  type={fullInput.type}
                  name={fullInput.name}
                  className='py-2 absolut focus:outline-none border-t-bk border-hf focus:ring focus:b-mc w-full h-14 px-4 rounded-lg'
                  value={fullInput.value}
                  onChange={fullInput.onchange}
                  required
                />
              </div>
            ))}
          </div>
        </div>
        <div className='flex flex-row gap-6'>
          <button
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-2 md:px-8 py-2.5 w-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md'
            disabled={isSubmiting}
          >
            {!isSubmiting ? (
              '+ Add bank account'
            ) : (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
              />
            )}
          </button>
          <FitButtons
            details='Cancel'
            color='cancel'
            icon={false}
            onClick={props.toggleAddAccountForm}
          />
        </div>
      </form>
    </section>
  );
};
